var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.121 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 224484"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Arrow - Down 2"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 1",
  d: "m15.061 5-7 7-7-7",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
})))));
export default SvgChevronDown;